module.exports = __webpack_public_path__ + "img/box.ebf5d85f.svg";